<ems-toast-message #toastMessage></ems-toast-message>

<sdps-notification type="error" class="sdps-m-top_none" *ngIf="filterBtnDisable || (manageClientListForm.get('clientName').value && manageClientListForm.get('clientName').errors?.clientNameValidation === false && manageClientListForm.get('clientName').errors?.emsStartSpacePattern !== false) || clientNameValidationMinChar">
  <div class="sdps-notification__text">
    <p [innerHTML]="shellConstant.manageUserPage.errorMsg.pleaseCorrectFollowingError"></p>
    <ul class="sdps-navigation--horizontal__list error-list">
      <li *ngIf="filterBtnDisable || clientNameValidationMinChar"
          [innerHTML]="shellConstant.manageUserPage.managerUserFilterErrorMsgs.minCharLimitErrorMsg">
      </li>
      <li *ngIf="emsClientNamePatterncheck || manageClientListForm.get('clientName').invalid"
          [innerHTML]="shellConstant.manageClients.clientDetailsPage.errorMsg.invalidCharacterForName">
      </li>
    </ul>
  </div>
</sdps-notification>

<h2 class="page-title sdps-m-bottom_large sdps-display-inline-block"
    [innerHTML]="shellConstant.manageClients.mangeClientList.manageClientsLabel"></h2>
<span class="sdps-m-horizontal_large sdps-display-inline-block client-selection-indicator"
      [ngClass]="this.externalAccess ? 'external-access' : sharedService.showHistoricalView.value ? 'inactive-red' : (addlinkService.clientInformation | async)?.businessUnit | lowercase"
        [innerHTML]="(addlinkService.clientInformation | async)?.k4ClientName">
</span>

<ems-service-error *ngIf="sharedService.errorMessage | async"></ems-service-error>

<div>
  <button *ngIf="displaySetupNewClient" type="button" class="buttons button-save sdps-pull-left sdps-m-top_small sdps-m-left_small"
          (click)="navigateToSetupNewClient()">
    <em class="pi pi-plus"></em>
    {{shellConstant.manageClients.mangeClientList.setupNewClient}}
  </button>

  <ems-table-record-count *ngIf ="showTotalRecords" class="tbl-rec-count" [count]="totalClients" [showTotal]="totalClients"
                          (emitter)="pageObject.pageNo = 0;pageObject.pageSize = $event;applyFilter()"
                          [showHeaderIcons]="true" [storedVal] = 'tablePageSize' [showRecords]="paginationCount && paginationCount > sharedConstant.defaultTableRecords"></ems-table-record-count>

                          <ems-table-record-count class="ems-show-record" *ngIf="!showTotalRecords && displaySetupNewClient"></ems-table-record-count>
  <form [formGroup]="manageClientListForm">
  <p-table [columns]="manageClientListTableCols" [value]="clientList" dataKey="id" [customSort]="true"
           metaKeySelection="true" [lazy]="true" (onLazyLoad)="customSort($event)" [multiSortMeta]="multiSortMeta"
           sortMode="multiple" class="common-data-table manage-client-list-table custom-table-filter">
           <ng-template #sorticon pTemplate="sorticon" let-sortOrder>
            <span class="pi" [ngClass]="{
                  'pi-sort': sortOrder === 0,
                  'pi-caret-down': sortOrder === -1,
                  'pi-caret-up': sortOrder === 1,
                }"></span>
          </ng-template>
           <ng-template pTemplate="header" let-columns>
      <tr class="filter-header-input">
        <th class="table-checkbox-selection filter-icon" *ngIf="this.getOrgId === 0" aria-label="Filter controls">
          <span class="sr-only">Filter controls</span>
          <button type="button" class="btn-icon-only cursor" (click)="sharedService.gutTracking('adobe-fl_manageclientsfilter|fireonce'); toggleFctn()" aria-label="Toggle filter" [attr.aria-expanded]="toggle">
            <em class="pi pi-filter" aria-hidden="true"></em>
          </button>
        </th>
        <ng-container *ngFor="let col of columns">
          <th *ngIf="col.field !== 'actions'" [attr.aria-label]="col.header || 'Column'" [pSortableColumn]="col.field" (click)="getOrgId === 0 ? clearSuccessAndErrorMessages() : ''"
            [pSortableColumnDisabled]="col.field === 'masterAccount' || this.getOrgId !== 0"
            [ngClass]="[(col.header === shellConstant.manageClients.clientDetailsPage.clientRegName ? 'w-13-per': ''), ((paginationCount && paginationCount > 1 || filterClicked) ? 'pointer-events-auto' : 'pointer-events-none')]">
            {{col.header || 'Column'}}
            <p-sortIcon [field]="col.field" *ngIf="(col.field !=='masterAccount' && col.field !=='actions' && this.getOrgId === 0)  && (paginationCount && paginationCount > 1 || filterClicked)"></p-sortIcon>
          </th>
          <th *ngIf="col.field === 'actions' && toggle && this.getOrgId === 0" [attr.aria-label]="col.header || 'Actions'" [ngClass]="'w-200-px'">
            {{col.header || 'Actions'}}
          </th>
        </ng-container>
      </tr>
      <tr *ngIf="this.toggle && this.getOrgId === 0" class="filtered-row-input">
        <th *ngIf="sharedService.checkEntitlements(entitlementConst.navUUID.manageClient.uuid, '', '')" aria-label="Filter controls"><span class="sr-only">Filter controls</span></th>
        <th *ngFor="let col of columns ; let i = index;" class="sdps-p-left_small">
          <label class="sr-only" [for]="'client_' + col.field" *ngIf="col.field === 'clientName'">{{col.header}} filter</label>
          <input pInputText [attr.aria-label]="col.header + ' filter'" emsClientNamePatterncheck emsStartSpaceValidator [maxLength]="200"  id="client_{{col.field}}"
          (keydown.enter)="!(filterBtnDisable || manageClientListForm.get('clientName').invalid || manageClientListForm.invalid ) ? applyFilter() : ''" onkeydown="return (event.keyCode !== 13);" formControlName="{{col.field}}" class="w-100-per" type="text" name="filter" *ngIf="col.field === 'clientName'" [ngClass]="{'invalidField': (manageClientListForm.get('clientName').value && clientNameValidationMinChar || manageClientListForm.get('clientName').invalid)}">
          <label class="sr-only" [for]="'client_' + col.field" *ngIf="col.field === 'custId'">{{col.header}} filter</label>
          <input pInputText [attr.aria-label]="col.header + ' filter'" id="client_{{col.field}}" formControlName="{{col.field}}" class="w-100-per" type="text" name="filter" (keydown.enter)="!(filterBtnDisable || manageClientListForm.invalid) ? applyFilter() : ''" onkeydown="return (event.keyCode !== 13);"
            onkeypress="return (event.which >= 48 && event.which <= 57)" *ngIf="col.field === 'custId'"
            [ngClass]="{'disabled': disableCustId, 'invalidField': (manageClientListForm.get('custId').value && filterBtnDisable)}" [readOnly]="disableCustId" [maxLength]="10">

          <label class="sr-only" [for]="'client_' + col.field" *ngIf="col.field === 'masterAccount'">{{col.header}} filter</label>
          <input pInputText [attr.aria-label]="col.header + ' filter'" id="client_{{col.field}}" formControlName="{{col.field}}" class="w-100-per" type="text" name="filter" (keydown.enter)="!(filterBtnDisable || manageClientListForm.invalid) ? applyFilter() : ''" onkeydown="return (event.keyCode !== 13);"
                 onkeypress="return (event.which >= 48 && event.which <= 57)" *ngIf="col.field === 'masterAccount'"
                 [ngClass]="{'disabled': disableK4Master, 'invalidField': (manageClientListForm.get('masterAccount').value && filterBtnDisable)}" [readOnly]="disableK4Master" [maxLength]="8">

          <!-- Integrated Primeng Date-Range Component -->
          <ems-date-range-filter id="client_{{col.enum}}" #range [disableForm]="filterState === 'disable'" (submittedDate)="getSelectedDate($event);" *ngIf="col.enum === 'calendar'">
          </ems-date-range-filter>

          <div class="timePickerForm link-type-bu-filter" *ngIf="col.enum === 'dropdown' && col.field !== 'businessUnit'">
            <label class="sr-only" [for]="'client_' + col.field">{{col.header}} filter</label>
            <p-select [inputId]="'client_' + col.field" [options]="shellConstant.manageClients.mangeClientList[col.field]" placeholder=" "
              [attr.aria-label]="col.header + ' filter'" formControlName="{{col.field}}" class="editableTimepicker request-list-header-dropdown"
              optionLabel="label">
            </p-select>
          </div>

          <div class="timePickerForm link-type-bu-filter" *ngIf="col.enum === 'dropdown' && col.field === 'businessUnit'">
            <label class="sr-only" [for]="'client_' + col.field">{{col.header}} filter</label>
            <p-select [inputId]="'client_' + col.field" [options]="userBUData" placeholder=" "
                        [attr.aria-label]="col.header + ' filter'" formControlName="{{col.field}}" class="editableTimepicker request-list-header-dropdown"
                        optionLabel="label">
            </p-select>
          </div>
          <div *ngIf="col.field === 'actions'" class="w-200-px">
            <button class="buttons button-filter" [innerHTML]="getAdlConst.requestListFilterButtons.clearAllButton"
              [disabled]="!manageClientListForm.dirty && !isSortingChanged"
              (click)="isClickedClearBtn = true;filterClicked? clickedClearBtn(isSortingChanged) : resetForm(isSortingChanged); clearSuccessAndErrorMessages();"></button>
            <button class="buttons button-save button-filter" [disabled]="filterBtnDisable || manageClientListForm.invalid || clientNameValidationMinChar"
              [innerHTML]="getAdlConst.requestListFilterButtons.applyFilterButton" (click)="applyFilter()"></button>
          </div>
          <div class="timePickerForm link-type-bu-filter" *ngIf="col.field === 'activeStatus'">
            <label class="sr-only" [for]="'client_' + col.field">{{col.header}} filter</label>
            <p-select [inputId]="'client_' + col.field" [options]="shellConstant.manageClients.mangeClientList['statusClient']" placeholder=" "
                        [attr.aria-label]="col.header + ' filter'" formControlName="{{col.field}}" class="editableTimepicker request-list-header-dropdown"
                        optionLabel="label">
            </p-select>
          </div>
        </th>
      </tr>

      <!-- Sub-header header section -->
      <tr *ngIf="this.toggle && this.getOrgId === 0" class="filter-header-input">
        <th class="table-checkbox-selection filter-icon" aria-label="Selection"><span class="sr-only">Selection</span></th>
        <th aria-label="Client details"><span class="sr-only">Client details</span></th>
        <th *ngFor="let col of manageClientListTableSubHeaderCols">
          {{col.header}}
        </th>
        <th class="filter-action" aria-label="Filter actions"><span class="sr-only">Filter actions</span></th>
      </tr>

      <!-- Sub-header filter field section -->
      <tr *ngIf="this.toggle && this.getOrgId === 0" class="filtered-row-input">
        <th aria-label="Filter row"><span class="sr-only">Filter row</span></th>
        <th aria-label="Filter row"><span class="sr-only">Filter row</span></th>
        <th class="sdps-p-left_small">
          <div class="timePickerForm emtr-dropdown access-type-dropdown">
            <label class="sr-only" for="client_accessType">Access Type filter</label>
            <p-select inputId="client_accessType" [options]="shellConstant.manageClients.mangeClientList['accessType']" placeholder=" "
                        aria-label="Access Type filter" formControlName="accessType" optionLabel="label">
            </p-select>
          </div>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length + 1" class="sdps-text-center"
            [innerHTML]="shellConstant.manageUserPage.noRecords"></td>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr [pSelectableRow]="rowData">
        <td class="col-1" *ngIf="this.getOrgId === 0"></td>
        <ng-container *ngFor="let col of columns">
          <td *ngIf="col.field !== 'actions'" [ngClass]="col.field === 'clientName' ? 'word-break' : 'sdps-truncate--ellipses'">
            <button *ngIf="col.field === 'clientName'" type="button" class="ruleGrpLinks cursor btn-text-link"
                    (click)="editClient(rowData['orgId'])"
                    [attr.aria-label]="'Edit client ' + rowData['k4ClientName']"
                [innerHTML]="rowData['k4ClientName']"></button>
            <span *ngIf="col.field === 'custId'" [innerHTML]="rowData[col.field]"></span>
            <ng-container *ngIf="col.field === 'masterAccount'">
              <div *ngFor="let obj of rowData.clientMasterAccounts">
                <div *ngIf="rowData.clientMasterAccounts.length === 1">{{obj.masterAccountNbr}} ({{obj.accountType}})</div>
                <div *ngIf="rowData.clientMasterAccounts.length > 1 && obj.accountType === shellConstant.k4Text">
                  {{obj.masterAccountNbr}} ({{obj.accountType}})</div>
              </div>
            </ng-container>
            <span
              *ngIf="col.field !== 'clientName' && col.field !== 'activeStatus' && col.field !== 'custId' && col.field !== 'modifiedDate' && col.field !== 'applications'"
              [innerHTML]="rowData[col.field]"></span>
            <span *ngIf="col.field === 'applications'" [innerHTML]="removeEmptyValue(rowData[col.field])"></span>
            <span *ngIf="col.field === 'activeStatus'">
              <span class="status sdps-p-around-xx-large" ngClass="{{rowData[col.field] | lowercase}}">
                <span class="sdps-m-left_large" [innerHTML]="rowData[col.field]"></span>
              </span>
            </span>
            <span *ngIf="col.field === 'modifiedDate'"
              [innerHTML]="rowData[col.field]? moment(rowData[col.field]).format('MM/DD/YYYY') : ''"></span>
          </td>
          <td *ngIf="col.field === 'actions' && toggle && this.getOrgId === 0" [ngClass]="'w-200-px'"></td>
        </ng-container>
      </tr>
    </ng-template>
  </p-table>
  </form>

  <p-paginator [alwaysShow]="paginationCount && paginationCount > sharedConstant.defaultTableRecords ? true : false" class="common-pagination" [rows]="pageObject.pageSize" [totalRecords]="paginationCount"
  (onPageChange)="paginate($event);" #p></p-paginator>

</div>
